// Quote Module Translations - Lithuanian (default) and English

export const translations = {
  lt: {
    // Common
    common: {
      save: 'Išsaugoti',
      cancel: 'Atšaukti',
      delete: 'Ištrinti',
      edit: 'Redaguoti',
      create: 'Sukurti',
      search: 'Ieškoti',
      filter: 'Filtruoti',
      loading: 'Kraunama...',
      noData: 'Nėra duomenų',
      confirm: 'Patvirtinti',
      close: 'Uždaryti',
      yes: 'Taip',
      no: 'Ne',
      back: 'Atgal',
      next: 'Toliau',
      all: 'Visi',
      actions: 'Veiksmai',
      status: 'Būsena',
      date: 'Data',
      total: 'Viso',
      download: 'Atsisiųsti',
      upload: 'Įkelti',
      send: 'Siųsti',
      duplicate: 'Dubliuoti',
      view: 'Peržiūrėti',
      pdf: 'PDF',
      excel: 'Excel',
      export: 'Eksportuoti',
      language: 'Kalba',
    },

    // Navigation
    nav: {
      dashboard: 'Valdymo skydelis',
      quotes: 'Pasiūlymai',
      clients: 'Klientai',
      catalog: 'Katalogas',
      templates: 'Šablonai',
      documents: 'Dokumentai',
      accounts: 'Paskyros',
      logout: 'Atsijungti',
      changePassword: 'Keisti slaptažodį',
    },

    // Login
    login: {
      title: 'Prisijungimas',
      subtitle: 'Pasiūlymų valdymo sistema',
      email: 'El. paštas',
      password: 'Slaptažodis',
      submit: 'Prisijungti',
      loading: 'Jungiamasi...',
      error: 'Neteisingi prisijungimo duomenys',
      forgotPassword: 'Pamiršote slaptažodį?',
    },

    // Dashboard
    dashboard: {
      title: 'Valdymo skydelis',
      welcome: 'Sveiki',
      totalQuotes: 'Viso pasiūlymų',
      drafts: 'Juodraščiai',
      sent: 'Išsiųsti',
      accepted: 'Priimti',
      totalValue: 'Bendra vertė',
      thisMonth: 'Šį mėnesį',
      recentQuotes: 'Naujausi pasiūlymai',
      quotesOverTime: 'Pasiūlymai per laiką',
      noRecentQuotes: 'Nėra naujausių pasiūlymų',
      createFirst: 'Sukurkite pirmą pasiūlymą',
    },

    // Quotes
    quotes: {
      title: 'Pasiūlymai',
      newQuote: 'Naujas pasiūlymas',
      searchPlaceholder: 'Ieškoti pagal numerį ar klientą...',
      filterByStatus: 'Filtruoti pagal būseną',
      exportExcel: 'Eksportuoti Excel',
      noQuotes: 'Nėra pasiūlymų',
      createFirst: 'Sukurkite pirmą pasiūlymą pradėti',
      
      // Status
      status: {
        all: 'Visi',
        draft: 'Juodraštis',
        sent: 'Išsiųstas',
        accepted: 'Priimtas',
        expired: 'Pasibaigęs',
      },

      // Table headers
      table: {
        number: 'Numeris',
        client: 'Klientas',
        total: 'Suma',
        status: 'Būsena',
        created: 'Sukurta',
        actions: 'Veiksmai',
      },

      // Actions
      actions: {
        edit: 'Redaguoti',
        duplicate: 'Dubliuoti',
        downloadPdf: 'Atsisiųsti PDF',
        send: 'Siųsti',
      },
    },

    // Quote Editor
    quoteEditor: {
      newQuote: 'Naujas pasiūlymas',
      basicInfo: 'Pagrindinė informacija',
      seller: 'Pardavėjas',
      client: 'Klientas',
      selectClient: '-- Pasirinkite klientą --',
      documentLanguage: 'Dokumento kalba',
      validityDays: 'Galiojimas (dienų)',
      
      // Items
      items: {
        title: 'Prekės ir paslaugos',
        freeLine: 'Laisva eilutė',
        code: 'Kodas',
        name: 'Pavadinimas',
        quantity: 'Kiekis',
        unitPrice: 'Vnt. kaina',
        total: 'Suma',
        addFromCatalog: 'Pridėkite prekių iš katalogo',
        noItems: 'Nėra prekių',
      },

      // Discount & Conditions
      discount: {
        title: 'Nuolaida ir sąlygos',
        discountPct: 'Nuolaida (%)',
        vatPct: 'PVM (%)',
        discountReason: 'Nuolaidos priežastis',
        discountReasonPlaceholder: 'Pvz.: Nuolaida kiekiui',
        conditions: 'Papildomos sąlygos',
        conditionsPlaceholder: 'Pvz.: Pristatymo laikas, specialios sąlygos...',
      },

      // Totals
      totals: {
        title: 'Suma',
        subtotal: 'Tarpinė suma',
        discount: 'Nuolaida',
        netAmount: 'Suma be PVM',
        vat: 'PVM',
        totalWithVat: 'Viso su PVM',
      },

      // Catalog
      catalog: {
        title: 'Katalogas',
      },

      // Attachments
      attachments: {
        title: 'Priedai (Datasheets)',
        uploadPrompt: 'Paspauskite, kad įkeltumėte failą',
        uploadFormats: 'PDF, DOC, DOCX, XLS, XLSX, PNG, JPG (iki 25 MB)',
        uploading: 'Įkeliama...',
        noFiles: 'Nėra pridėtų failų',
        fileCount: 'failas(-ai)',
        filesNote: 'Šie failai bus pridėti prie PDF ir el. laiško',
        fileTooLarge: 'Failas per didelis. Maksimalus dydis yra 25 MB',
        uploadSuccess: 'Failas įkeltas',
        deleteConfirm: 'Ar tikrai norite ištrinti',
        deleted: 'Failas ištrintas',
      },

      // Templates
      templates: {
        title: 'Pasirinkite šabloną',
        noTemplates: 'Nėra sukurtų šablonų',
        button: 'Šablonas',
        applied: 'Šablonas pritaikytas',
        items: 'prekių',
      },

      // Validation
      validation: {
        selectClient: 'Pasirinkite klientą',
        addItems: 'Pridėkite bent vieną prekę',
      },

      // Messages
      messages: {
        saved: 'Pasiūlymas išsaugotas',
        created: 'Pasiūlymas sukurtas',
        saving: 'Saugoma...',
      },
    },

    // Send Quote Modal
    sendQuote: {
      title: 'Siųsti pasiūlymą',
      quote: 'Pasiūlymas',
      client: 'Klientas',
      recipientEmail: 'Gavėjo el. paštas',
      cc: 'CC (atskirti kableliu)',
      ccPlaceholder: 'el.pastas1@pvz.lt, el.pastas2@pvz.lt',
      message: 'Žinutė (neprivaloma)',
      messagePlaceholder: 'Papildoma žinutė gavėjui...',
      messageNote: 'Jei tuščia, bus naudojamas standartinis tekstas.',
      sending: 'Siunčiama...',
      sent: 'Pasiūlymas išsiųstas sėkmingai',
      enterEmail: 'Įveskite gavėjo el. paštą',
    },

    // Clients
    clients: {
      title: 'Klientai',
      newClient: 'Naujas klientas',
      searchPlaceholder: 'Ieškoti pagal pavadinimą...',
      noClients: 'Nėra klientų',
      createFirst: 'Sukurkite pirmą klientą pradėti',
      
      // Form fields
      form: {
        name: 'Pavadinimas',
        country: 'Šalis',
        language: 'Kalba',
        vatNumber: 'PVM kodas',
        address: 'Adresas',
        contactName: 'Kontaktinis asmuo',
        contactEmail: 'El. paštas',
        contactPhone: 'Telefonas',
      },

      // Messages
      messages: {
        created: 'Klientas sukurtas',
        updated: 'Klientas atnaujintas',
        deleted: 'Klientas ištrintas',
        deleteConfirm: 'Ar tikrai norite ištrinti šį klientą?',
        nameRequired: 'Pavadinimas privalomas',
      },
    },

    // Catalog
    catalog: {
      title: 'Produktų katalogas',
      newProduct: 'Naujas produktas',
      searchPlaceholder: 'Ieškoti pagal kodą ar pavadinimą...',
      noProducts: 'Nėra produktų',
      
      // Categories
      categories: {
        all: 'Visos kategorijos',
        Knygomatai: 'Knygomatai',
        Paslaugos: 'Paslaugos',
        'Grąžinimo dėžės': 'Grąžinimo dėžės',
        Detektoriai: 'Detektoriai',
        Kita: 'Kita',
      },

      // Form
      form: {
        code: 'Kodas',
        name: 'Pavadinimas',
        category: 'Kategorija',
        price: 'Kaina (€)',
        active: 'Aktyvus',
      },

      // Messages
      messages: {
        created: 'Produktas sukurtas',
        updated: 'Produktas atnaujintas',
        codeRequired: 'Kodas privalomas',
        nameRequired: 'Pavadinimas privalomas',
      },
    },

    // Templates
    templates: {
      title: 'Pasiūlymų šablonai',
      newTemplate: 'Naujas šablonas',
      searchPlaceholder: 'Ieškoti pagal pavadinimą...',
      noTemplates: 'Nėra šablonų',
      createFirst: 'Sukurkite pirmą šabloną',
      useTemplate: 'Naudoti šabloną',
      
      // Form
      form: {
        name: 'Pavadinimas',
        description: 'Aprašymas',
        entity: 'Pardavėjas',
        language: 'Kalba',
        validityDays: 'Galiojimas (dienų)',
        vatRate: 'PVM (%)',
        discountPct: 'Nuolaida (%)',
        conditions: 'Sąlygos',
        items: 'Prekės',
      },

      // Messages
      messages: {
        created: 'Šablonas sukurtas',
        updated: 'Šablonas atnaujintas',
        deleted: 'Šablonas ištrintas',
        deleteConfirm: 'Ar tikrai norite ištrinti šį šabloną?',
        nameRequired: 'Pavadinimas privalomas',
      },
    },

    // Documents
    documents: {
      title: 'Dokumentai',
      newDocument: 'Naujas dokumentas',
      noDocuments: 'Nėra dokumentų',
      
      form: {
        title: 'Pavadinimas',
        category: 'Kategorija',
        language: 'Kalba',
        version: 'Versija',
        url: 'Nuoroda',
        published: 'Paskelbtas',
      },
    },

    // Accounts
    accounts: {
      title: 'Vartotojų paskyros',
      newUser: 'Naujas vartotojas',
      searchPlaceholder: 'Ieškoti pagal vardą ar el. paštą...',
      noUsers: 'Nėra vartotojų',
      
      // Roles
      roles: {
        user: 'Vartotojas',
        admin: 'Administratorius',
        superadmin: 'Super administratorius',
      },

      // Status
      status: {
        active: 'Aktyvus',
        suspended: 'Sustabdytas',
      },

      // Form
      form: {
        name: 'Vardas',
        email: 'El. paštas',
        role: 'Rolė',
        status: 'Būsena',
        canEditProducts: 'Gali redaguoti produktus',
        password: 'Slaptažodis',
        passwordNote: 'Palikus tuščią, bus sugeneruotas automatiškai',
      },

      // Actions
      actions: {
        resetPassword: 'Atstatyti slaptažodį',
        sendCredentials: 'Siųsti prisijungimo duomenis',
        suspend: 'Sustabdyti',
        activate: 'Aktyvuoti',
      },

      // Messages
      messages: {
        created: 'Vartotojas sukurtas',
        updated: 'Vartotojas atnaujintas',
        deleted: 'Vartotojas ištrintas',
        passwordReset: 'Slaptažodis atstatytas',
        credentialsSent: 'Prisijungimo duomenys išsiųsti',
        deleteConfirm: 'Ar tikrai norite ištrinti šį vartotoją?',
        cannotDeleteSelf: 'Negalite ištrinti savo paskyros',
      },
    },

    // Change Password
    changePassword: {
      title: 'Keisti slaptažodį',
      currentPassword: 'Dabartinis slaptažodis',
      newPassword: 'Naujas slaptažodis',
      confirmPassword: 'Patvirtinti slaptažodį',
      submit: 'Keisti slaptažodį',
      success: 'Slaptažodis pakeistas sėkmingai',
      passwordMismatch: 'Slaptažodžiai nesutampa',
      passwordTooShort: 'Slaptažodis turi būti bent 8 simbolių',
    },

    // Errors
    errors: {
      generic: 'Įvyko klaida',
      unauthorized: 'Neturite teisių atlikti šį veiksmą',
      notFound: 'Nerasta',
      serverError: 'Serverio klaida',
      networkError: 'Tinklo klaida',
      sessionExpired: 'Sesija pasibaigė. Prisijunkite iš naujo.',
    },

    // Email templates
    email: {
      quoteSubject: 'Komercinis pasiūlymas',
      quoteGreeting: 'Gerbiamas kliente',
      quoteIntro: 'Siunčiame Jums komercinį pasiūlymą',
      quoteAttached: 'Pasiūlymas pridėtas PDF formatu.',
      quoteDatasheets: 'Papildomi dokumentai (datasheets):',
      quoteValidUntil: 'Pasiūlymas galioja iki',
      quoteContact: 'Jei turite klausimų, susisiekite su mumis.',
      quoteRegards: 'Pagarbiai',
      reminderSubject: 'Priminimas: Pasiūlymo galiojimas baigiasi',
      reminderIntro: 'Primename, kad Jūsų pasiūlymo galiojimas netrukus baigsis.',
    },
  },

  en: {
    // Common
    common: {
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      create: 'Create',
      search: 'Search',
      filter: 'Filter',
      loading: 'Loading...',
      noData: 'No data',
      confirm: 'Confirm',
      close: 'Close',
      yes: 'Yes',
      no: 'No',
      back: 'Back',
      next: 'Next',
      all: 'All',
      actions: 'Actions',
      status: 'Status',
      date: 'Date',
      total: 'Total',
      download: 'Download',
      upload: 'Upload',
      send: 'Send',
      duplicate: 'Duplicate',
      view: 'View',
      pdf: 'PDF',
      excel: 'Excel',
      export: 'Export',
      language: 'Language',
    },

    // Navigation
    nav: {
      dashboard: 'Dashboard',
      quotes: 'Quotes',
      clients: 'Clients',
      catalog: 'Catalog',
      templates: 'Templates',
      documents: 'Documents',
      accounts: 'Accounts',
      logout: 'Logout',
      changePassword: 'Change Password',
    },

    // Login
    login: {
      title: 'Login',
      subtitle: 'Quote Management System',
      email: 'Email',
      password: 'Password',
      submit: 'Sign In',
      loading: 'Signing in...',
      error: 'Invalid credentials',
      forgotPassword: 'Forgot password?',
    },

    // Dashboard
    dashboard: {
      title: 'Dashboard',
      welcome: 'Welcome',
      totalQuotes: 'Total Quotes',
      drafts: 'Drafts',
      sent: 'Sent',
      accepted: 'Accepted',
      totalValue: 'Total Value',
      thisMonth: 'This Month',
      recentQuotes: 'Recent Quotes',
      quotesOverTime: 'Quotes Over Time',
      noRecentQuotes: 'No recent quotes',
      createFirst: 'Create your first quote',
    },

    // Quotes
    quotes: {
      title: 'Quotes',
      newQuote: 'New Quote',
      searchPlaceholder: 'Search by number or client...',
      filterByStatus: 'Filter by status',
      exportExcel: 'Export to Excel',
      noQuotes: 'No quotes found',
      createFirst: 'Create your first quote to get started',
      
      status: {
        all: 'All',
        draft: 'Draft',
        sent: 'Sent',
        accepted: 'Accepted',
        expired: 'Expired',
      },

      table: {
        number: 'Number',
        client: 'Client',
        total: 'Total',
        status: 'Status',
        created: 'Created',
        actions: 'Actions',
      },

      actions: {
        edit: 'Edit',
        duplicate: 'Duplicate',
        downloadPdf: 'Download PDF',
        send: 'Send',
      },
    },

    // Quote Editor
    quoteEditor: {
      newQuote: 'New Quote',
      basicInfo: 'Basic Information',
      seller: 'Seller',
      client: 'Client',
      selectClient: '-- Select a client --',
      documentLanguage: 'Document Language',
      validityDays: 'Validity (days)',
      
      items: {
        title: 'Products and Services',
        freeLine: 'Free Line',
        code: 'Code',
        name: 'Name',
        quantity: 'Qty',
        unitPrice: 'Unit Price',
        total: 'Total',
        addFromCatalog: 'Add products from catalog',
        noItems: 'No items',
      },

      discount: {
        title: 'Discount and Conditions',
        discountPct: 'Discount (%)',
        vatPct: 'VAT (%)',
        discountReason: 'Discount Reason',
        discountReasonPlaceholder: 'E.g.: Volume discount',
        conditions: 'Additional Conditions',
        conditionsPlaceholder: 'E.g.: Delivery time, special conditions...',
      },

      totals: {
        title: 'Summary',
        subtotal: 'Subtotal',
        discount: 'Discount',
        netAmount: 'Net Amount',
        vat: 'VAT',
        totalWithVat: 'Total with VAT',
      },

      catalog: {
        title: 'Catalog',
      },

      attachments: {
        title: 'Attachments (Datasheets)',
        uploadPrompt: 'Click to upload a file',
        uploadFormats: 'PDF, DOC, DOCX, XLS, XLSX, PNG, JPG (up to 25 MB)',
        uploading: 'Uploading...',
        noFiles: 'No files attached',
        fileCount: 'file(s)',
        filesNote: 'These files will be attached to the PDF and email',
        fileTooLarge: 'File too large. Maximum size is 25 MB',
        uploadSuccess: 'File uploaded',
        deleteConfirm: 'Are you sure you want to delete',
        deleted: 'File deleted',
      },

      templates: {
        title: 'Select a Template',
        noTemplates: 'No templates available',
        button: 'Template',
        applied: 'Template applied',
        items: 'items',
      },

      validation: {
        selectClient: 'Please select a client',
        addItems: 'Please add at least one item',
      },

      messages: {
        saved: 'Quote saved',
        created: 'Quote created',
        saving: 'Saving...',
      },
    },

    // Send Quote Modal
    sendQuote: {
      title: 'Send Quote',
      quote: 'Quote',
      client: 'Client',
      recipientEmail: 'Recipient Email',
      cc: 'CC (separate with comma)',
      ccPlaceholder: 'email1@example.com, email2@example.com',
      message: 'Message (optional)',
      messagePlaceholder: 'Additional message to recipient...',
      messageNote: 'If empty, standard text will be used.',
      sending: 'Sending...',
      sent: 'Quote sent successfully',
      enterEmail: 'Please enter recipient email',
    },

    // Clients
    clients: {
      title: 'Clients',
      newClient: 'New Client',
      searchPlaceholder: 'Search by name...',
      noClients: 'No clients found',
      createFirst: 'Create your first client to get started',
      
      form: {
        name: 'Name',
        country: 'Country',
        language: 'Language',
        vatNumber: 'VAT Number',
        address: 'Address',
        contactName: 'Contact Person',
        contactEmail: 'Email',
        contactPhone: 'Phone',
      },

      messages: {
        created: 'Client created',
        updated: 'Client updated',
        deleted: 'Client deleted',
        deleteConfirm: 'Are you sure you want to delete this client?',
        nameRequired: 'Name is required',
      },
    },

    // Catalog
    catalog: {
      title: 'Product Catalog',
      newProduct: 'New Product',
      searchPlaceholder: 'Search by code or name...',
      noProducts: 'No products found',
      
      categories: {
        all: 'All Categories',
        Knygomatai: 'Book Kiosks',
        Paslaugos: 'Services',
        'Grąžinimo dėžės': 'Return Boxes',
        Detektoriai: 'Detectors',
        Kita: 'Other',
      },

      form: {
        code: 'Code',
        name: 'Name',
        category: 'Category',
        price: 'Price (€)',
        active: 'Active',
      },

      messages: {
        created: 'Product created',
        updated: 'Product updated',
        codeRequired: 'Code is required',
        nameRequired: 'Name is required',
      },
    },

    // Templates
    templates: {
      title: 'Quote Templates',
      newTemplate: 'New Template',
      searchPlaceholder: 'Search by name...',
      noTemplates: 'No templates found',
      createFirst: 'Create your first template',
      useTemplate: 'Use Template',
      
      form: {
        name: 'Name',
        description: 'Description',
        entity: 'Seller',
        language: 'Language',
        validityDays: 'Validity (days)',
        vatRate: 'VAT (%)',
        discountPct: 'Discount (%)',
        conditions: 'Conditions',
        items: 'Items',
      },

      messages: {
        created: 'Template created',
        updated: 'Template updated',
        deleted: 'Template deleted',
        deleteConfirm: 'Are you sure you want to delete this template?',
        nameRequired: 'Name is required',
      },
    },

    // Documents
    documents: {
      title: 'Documents',
      newDocument: 'New Document',
      noDocuments: 'No documents found',
      
      form: {
        title: 'Title',
        category: 'Category',
        language: 'Language',
        version: 'Version',
        url: 'URL',
        published: 'Published',
      },
    },

    // Accounts
    accounts: {
      title: 'User Accounts',
      newUser: 'New User',
      searchPlaceholder: 'Search by name or email...',
      noUsers: 'No users found',
      
      roles: {
        user: 'User',
        admin: 'Admin',
        superadmin: 'Super Admin',
      },

      status: {
        active: 'Active',
        suspended: 'Suspended',
      },

      form: {
        name: 'Name',
        email: 'Email',
        role: 'Role',
        status: 'Status',
        canEditProducts: 'Can edit products',
        password: 'Password',
        passwordNote: 'Leave empty to auto-generate',
      },

      actions: {
        resetPassword: 'Reset Password',
        sendCredentials: 'Send Credentials',
        suspend: 'Suspend',
        activate: 'Activate',
      },

      messages: {
        created: 'User created',
        updated: 'User updated',
        deleted: 'User deleted',
        passwordReset: 'Password reset',
        credentialsSent: 'Credentials sent',
        deleteConfirm: 'Are you sure you want to delete this user?',
        cannotDeleteSelf: 'You cannot delete your own account',
      },
    },

    // Change Password
    changePassword: {
      title: 'Change Password',
      currentPassword: 'Current Password',
      newPassword: 'New Password',
      confirmPassword: 'Confirm Password',
      submit: 'Change Password',
      success: 'Password changed successfully',
      passwordMismatch: 'Passwords do not match',
      passwordTooShort: 'Password must be at least 8 characters',
    },

    // Errors
    errors: {
      generic: 'An error occurred',
      unauthorized: 'You are not authorized to perform this action',
      notFound: 'Not found',
      serverError: 'Server error',
      networkError: 'Network error',
      sessionExpired: 'Session expired. Please log in again.',
    },

    // Email templates
    email: {
      quoteSubject: 'Commercial Quote',
      quoteGreeting: 'Dear Customer',
      quoteIntro: 'Please find attached our commercial quote',
      quoteAttached: 'The quote is attached in PDF format.',
      quoteDatasheets: 'Additional documents (datasheets):',
      quoteValidUntil: 'This quote is valid until',
      quoteContact: 'If you have any questions, please contact us.',
      quoteRegards: 'Best regards',
      reminderSubject: 'Reminder: Quote expiration approaching',
      reminderIntro: 'This is a reminder that your quote will expire soon.',
    },
  },
};

export default translations;
